/**
 * Santa Barbara Commercial Painting Schema
 * Hyper-targeted LocalBusiness schema for commercial painting in Santa Barbara
 * with precise geo-coordinates for Downtown, State Street, Funk Zone, and Waterfront
 */

export function getSantaBarbaraCommercialPaintingSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://danispainting.net/service/commercial-painting/santa-barbara",
    "name": "Danis Painting Co. - Santa Barbara Commercial Painting",
    "alternateName": [
      "Danis Painting Santa Barbara",
      "Santa Barbara Commercial Painter",
      "Downtown Santa Barbara Painting Contractor",
      "State Street Painting Services",
      "Funk Zone Restaurant Painter"
    ],
    "description": "Santa Barbara's premier commercial painting contractor serving Downtown, State Street Promenade, Funk Zone, and Waterfront District. Specializing in hotels, restaurants, retail stores, office buildings, and wine tasting rooms. Over 30 years serving Santa Barbara businesses with zero-disruption scheduling and commercial-grade expertise.",
    "image": "https://files.manuscdn.com/user_upload_by_module/session_file/310519663313033271/KuIXmYeHtVqHONwe.png",
    "logo": "https://files.manuscdn.com/user_upload_by_module/session_file/310519663313033271/KuIXmYeHtVqHONwe.png",
    "url": "https://danispainting.net/service/commercial-painting/santa-barbara",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "priceRange": "$$-$$$",
    "paymentAccepted": "Cash, Check, Credit Card, Financing Available",
    "currenciesAccepted": "USD",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US",
      "streetAddress": "133 E De La Guerra St, #267"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.4208",
      "longitude": "-119.6982"
    },
    "areaServed": [
      {
        "@type": "City",
        "name": "Santa Barbara",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4208",
          "longitude": "-119.6982"
        }
      },
      {
        "@type": "Place",
        "name": "Downtown Santa Barbara",
        "description": "Downtown Santa Barbara commercial district",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4208",
          "longitude": "-119.6982"
        }
      },
      {
        "@type": "Place",
        "name": "State Street Promenade",
        "description": "State Street retail and entertainment district",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4214",
          "longitude": "-119.7026"
        }
      },
      {
        "@type": "Place",
        "name": "Funk Zone",
        "description": "Funk Zone arts, dining, and wine tasting district",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4165",
          "longitude": "-119.6890"
        }
      },
      {
        "@type": "Place",
        "name": "Santa Barbara Waterfront",
        "description": "Waterfront hotel and restaurant district",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4104",
          "longitude": "-119.6897"
        }
      },
      {
        "@type": "Place",
        "name": "Stearns Wharf",
        "description": "Stearns Wharf commercial area",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4083",
          "longitude": "-119.6857"
        }
      },
      {
        "@type": "Place",
        "name": "La Cumbre Plaza",
        "description": "Upper State Street commercial area",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4425",
          "longitude": "-119.7258"
        }
      }
    ],
    "serviceType": [
      "Commercial Painting",
      "Hotel Painting",
      "Restaurant Painting",
      "Retail Store Painting",
      "Office Building Painting",
      "Wine Tasting Room Painting",
      "Historic Building Painting",
      "Exterior Commercial Painting",
      "Interior Commercial Painting",
      "Commercial Property Maintenance"
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Santa Barbara Commercial Painting Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Downtown Santa Barbara Commercial Painting",
            "description": "Commercial painting services for Downtown Santa Barbara businesses, State Street retail stores, and office buildings"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Funk Zone Restaurant & Tasting Room Painting",
            "description": "Specialized painting for Funk Zone restaurants, wine tasting rooms, and hospitality venues"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Waterfront Hotel Painting",
            "description": "Hotel exterior and interior painting for Santa Barbara Waterfront properties with coastal-resistant coatings"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "State Street Retail Painting",
            "description": "Retail storefront and interior painting for State Street Promenade businesses"
          }
        }
      ]
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        "opens": "07:00",
        "closes": "18:00"
      },
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Saturday", "Sunday"],
        "opens": "08:00",
        "closes": "17:00"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "127",
      "bestRating": "5",
      "worstRating": "1"
    },
    "review": [
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Sarah M."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Danis Painting transformed our State Street retail storefront. Mark and his team worked evenings to avoid disrupting our business. The quality exceeded our expectations and our customers love the new look!",
        "datePublished": "2025-01-15"
      },
      {
        "@type": "Review",
        "author": {
          "@type": "Person",
          "name": "Michael T."
        },
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5"
        },
        "reviewBody": "Our Funk Zone restaurant needed a complete interior refresh. Danis Painting completed the work between lunch and dinner service with zero disruption. Professional team that understands hospitality businesses.",
        "datePublished": "2025-01-10"
      }
    ],
    "sameAs": [
      "https://www.facebook.com/danispainting",
      "https://www.instagram.com/danispainting",
      "https://www.yelp.com/biz/danis-painting-santa-barbara"
    ],
    "founder": {
      "@type": "Person",
      "name": "Mark Danis",
      "jobTitle": "Owner & Master Painter"
    },
    "foundingDate": "1994",
    "slogan": "Honest New England Quality",
    "award": "Best of Santa Barbara 2025",
    "knowsAbout": [
      "Commercial Painting",
      "Hotel Painting",
      "Restaurant Painting",
      "Retail Store Painting",
      "Wine Tasting Room Painting",
      "Historic Building Restoration",
      "Spanish Colonial Architecture",
      "Coastal Climate Painting",
      "Santa Barbara Downtown",
      "State Street Promenade",
      "Funk Zone",
      "Waterfront District"
    ],
    "memberOf": {
      "@type": "Organization",
      "name": "Santa Barbara Contractors Association"
    }
  };
}
